module.exports = __webpack_public_path__ + "img/Designlazy_macbook-mockup 5.066a5a77.png";